import Logger from '@/search-page/platform/Logger';
import { PortalDefinitionHelper } from '../../models/definition';
import { PortalType } from '@studyportals/domain-client';
import store from '..';

export class ListenForPortalTypePlugin {
	public initiate(): void {
		this.addPortalTypeToState();
	}

	private addPortalTypeToState(): void {
		let portalType = window.PortalType;
		if (portalType === undefined) {
			Logger.logError('Portal type not found!');
			portalType = PortalType.PHD;
		}

		const portalDefinition = new PortalDefinitionHelper().getPortalDefinition(portalType);
		store.mutations.storePortalDefinition(portalDefinition);
		store.mutations.storePortalType(portalType);
	}
}
